import AuditInfo from '@components/Common/AuditInfo/AuditInfo';
import { Box, Typography } from '@mui/material';
import React from 'react';
import type { GlanceRow } from './types';

interface IdentityRailProps {
  initials: string;
  name: string;
  /** ID / slug shown in DM Mono under the name. */
  subId?: string;
  statusChip?: React.ReactNode;
  badges?: React.ReactNode;
  /** Primary full-width action + optional trailing icon buttons. */
  primaryAction?: React.ReactNode;
  secondaryActions?: React.ReactNode;
  glance: GlanceRow[];
  audit?: {
    createdAt?: string;
    createdBy?: string;
    updatedAt?: string;
    updatedBy?: string;
  };
}

const IdentityRail: React.FC<IdentityRailProps> = ({
  initials,
  name,
  subId,
  statusChip,
  badges,
  primaryAction,
  secondaryActions,
  glance,
  audit,
}) => (
  <Box className="cc-identity">
    <Box className="cc-identity__avatar">{initials}</Box>
    <Typography component="h2" className="cc-identity__name">
      {name}
    </Typography>
    {subId && <span className="cc-identity__id">{subId}</span>}

    {(statusChip || badges) && (
      <Box className="cc-identity__badges">
        {statusChip}
        {badges}
      </Box>
    )}

    {(primaryAction || secondaryActions) && (
      <Box className="cc-identity__actions">
        {primaryAction}
        {secondaryActions}
      </Box>
    )}

    {glance.length > 0 && (
      <Box className="cc-identity__block">
        <div className="cc-identity__block-label">At a glance</div>
        {glance.map((row) => (
          <Box key={row.key} className="cc-identity__glance-row">
            <span className="cc-identity__glance-key">{row.key}</span>
            <span
              className={`cc-identity__glance-value${row.mono ? ' is-mono' : ''}`}
              style={row.valueColor ? { color: row.valueColor } : undefined}
            >
              {row.value}
            </span>
          </Box>
        ))}
      </Box>
    )}

    {audit && (
      <Box className="cc-identity__audit">
        <div className="cc-identity__block-label">Record audit</div>
        <AuditInfo
          createdAt={audit.createdAt ?? ''}
          createdBy={audit.createdBy ?? ''}
          updatedAt={audit.updatedAt ?? ''}
          updatedBy={audit.updatedBy ?? ''}
        />
      </Box>
    )}
  </Box>
);

export default IdentityRail;
